'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

/**
 * TableBody component, used to display the body of a table. Renders a native HTML tbody element.
 *
 * @example
 * <TableBody>
 *   <TableRow>
 *     <TableCell>John</TableCell>
 *     <TableCell>25</TableCell>
 *   </TableRow>
 * </TableBody>
 */
const TableBody = forwardRef(function TableBody(rest, ref) {
    return jsx("tbody", { ref: ref, ...rest });
});

export { TableBody };
